export const campaignList = "CAMPAIGN_LIST";
export const campaignDetails = "CAMPAIGN_DETAILS";
export const attendeeList = "ATTENDEE_LIST";
export const campaignLogs = "CAMPAIGN_LOGS";
